import { jsx as l } from "react/jsx-runtime";
import { Spinner as i } from "../Spinner/index.js";
const t = ({ show: e = !0 }) => e && /* @__PURE__ */ l("div", { className: "absolute rounded-2xl top-0 left-0 w-full h-full z-20 bg-glassFill/50", children: /* @__PURE__ */ l("div", { className: "flex items-center flex-col justify-center h-full", children: /* @__PURE__ */ l(i, { size: "xl" }) }) });
export {
  t as LoadingSpinner
};
